import React, { useState, useEffect } from 'react';
import { getDeviceDataByID } from '../../services/deviceService';
import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import { Spin } from 'antd';
import DataTable from 'react-data-table-component';
import { DatePicker, Tooltip } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';
import { showError } from '../../services/toastService';

function TabularUI({ userData }) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const deviceId = queryParams.get('device');

    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentDate, setCurrentDate] = useState(dayjs());
    const [graphBVData, setGraphBVData] = useState();
    const [tableColumns, setTableColumn] = useState();
    const [macAddress, setMacAddress] = useState('');
    const [deviceName, setDeviceName] = useState('');

    const goToPreviousDay = () => {
        setCurrentDate((prevDate) => prevDate.subtract(1, 'day'));
        //getDeviceData(deviceId);
    };

    const goToNextDay = () => {
        const nextDate = currentDate.add(1, 'day');
        const today = dayjs(); // Get today's date
        // Check if the next date is in the future
        if (nextDate.isAfter(today)) {
            return; // Prevent future dates
        }
        setCurrentDate(nextDate);
        // getDeviceData(deviceId); // Fetch data for the next day
    };



    const getDeviceData = async (id) => {
        if (!id) {
            setError('Device ID not provided');
            return;
        }
        try {
            setLoading(true);
            const response = await getDeviceDataByID(id, currentDate.format('YYYY-MM-DD'));
            setMacAddress(response?.device?.mac);
            setDeviceName(response?.device?.name);
            // Transforming the graphSections to fit DataTable column format
            const transformedColumns = response?.device?.columns.map(column => ({
                name: (
                    <span style={{ textTransform: 'capitalize', fontWeight: 'bolder' }}>
                        {column.name}
                        <Tooltip title={column.description}>
                            <InfoCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                        </Tooltip>
                    </span>
                ),
                selector: row => row[column.name], // Assuming the row data uses column.name as a key
            }));
            const additionalColumns = [
                {
                    name: <span style={{ textTransform: 'capitalize', fontWeight: 'bolder' }}>
                        LogID
                        <Tooltip title="Log ID of the record">
                            <InfoCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                        </Tooltip>
                    </span>,
                    selector: row => row.LogID
                },
                {
                    name: <span style={{ textTransform: 'capitalize', fontWeight: 'bolder' }}>
                        Date
                        < Tooltip title="Date of the record" >
                            <InfoCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                        </Tooltip >
                    </span >, selector: row => row.Date,
                },
                {
                    name: <span style={{ textTransform: 'capitalize', fontWeight: 'bolder' }}>
                        Time
                        < Tooltip title="Time of the record" >
                            <InfoCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                        </Tooltip >
                    </span >, selector: row => row.Time,
                }
            ];
            const combinedColumns = [...additionalColumns, ...transformedColumns];
            setTableColumn(combinedColumns); // Set the combined columns
            if (Array.isArray(response?.graph)) {
                setGraphBVData(response.graph);
            } else {
                setGraphBVData([]);
            }

        } catch (error) {
            console.error('Error fetching device data:', error);
            setError('Failed to fetch device data');
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        if (deviceId) {
            setGraphBVData(null)
            getDeviceData(deviceId); // Re-fetch device data when deviceId is available
        }
    }, [currentDate, deviceId]); // Fetch data whenever currentDate or deviceId changes

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 'bold',
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: '#f4f4f4',
            },
        },
        table: {
            style: {
                border: '1px solid #f4f4f4',
                marginTop: 20
            },
        },
        headRow: {
            style: {
                //backgroundColor: '#f5f5f5',
                //borderBottom: '1px solid #ddd',
            },
        },
        // rows: {
        //     style: {
        //         borderBottom: '1px solid #ddd',
        //     },
        // },
        cells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: '#f4f4f4',
                },
            },
        },
    };

    const onChange = (date, dateString) => {
        setCurrentDate(date)
    };

    const disabledDate = (current) => {
        // Disable dates after today
        return current && current.isAfter(dayjs(), 'day');
    };

    return (
        <div className='content-wrappers'>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{deviceName ? deviceName : 'Device Name'} : <small>{macAddress ? macAddress : 'MAC Address'}</small></h3>
                        </div>
                        <div className="card-body">
                            <div className='col-12 text-center'>
                                <div className="row">
                                    <div className='col-3'>
                                        <i className="fa fa-arrow-left float-right" onClick={goToPreviousDay} style={{ fontSize: 25, cursor: 'pointer' }}></i>
                                    </div>
                                    <div className='col-6'>
                                        <div style={{ margin: '0 20px' }}>
                                            <DatePicker value={currentDate} onChange={onChange} readOnly format={'DD-MM-YYYY'} disabledDate={disabledDate} />
                                            {/* <input value={currentDate.format('DD-MM-YYYY')} readOnly style={{ textAlign: 'center' }} /> */}
                                        </div>
                                    </div>
                                    <div className='col-3'>
                                        <i className="fa fa-arrow-right float-left" onClick={goToNextDay} style={{ fontSize: 25, cursor: 'pointer' }}></i>
                                    </div>
                                </div>
                            </div>

                            {loading ?
                                (
                                    <div className="loading-container mt-20">
                                        <Spin fullscreen={false} size={'large'}>
                                            <div className="spinner"></div>
                                        </Spin>

                                    </div>
                                )
                                : <>
                                    {graphBVData && (
                                        <>
                                            <DataTable
                                                columns={tableColumns}
                                                data={graphBVData}
                                                progressPending={loading}
                                                pagination
                                                // selectableRows
                                                highlightOnHover
                                                customStyles={customStyles}
                                            />
                                        </>
                                    )}
                                </>

                            }



                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TabularUI;
